import Image from 'next/future/image';
import Link from 'next/link';

import { getEdgeUrl } from '@/lib/getEdgeUrl';

const DefaultHero = () => {
  const leftSection = getEdgeUrl('images/homepage/banner/v2/left-section.png');
  const rightSection = getEdgeUrl(
    'images/homepage/banner/v2/right-desktop.png',
  );
  const iphoneImage = getEdgeUrl('images/homepage/banner/v2/iphone.png');
  const switchImage = getEdgeUrl('images/homepage/banner/v2/switch.png');
  const smartwatchImage = getEdgeUrl(
    'images/homepage/banner/v2/smartwatch-v2.png',
  );

  return (
    <Link href="/collections/hot-deals" prefetch>
      <a
        className="relative flex
       h-full w-screen flex-col items-center justify-center overflow-hidden bg-teal-500 text-gray-700"
      >
        {/* Left Block  */}
        <div className="absolute bottom-0 hidden md:left-[-100px] md:block lg:left-[-130px] xl:left-[-40px]">
          <div className="h-[200px] lg:h-[250px]">
            <Image
              src={leftSection}
              alt="Left Section"
              loading="eager"
              height={800}
              width={800}
              className="h-full w-auto"
              priority
            />
          </div>
        </div>
        {/* Right Block */}
        <div className="absolute bottom-0 hidden md:right-[-280px] md:block lg:right-[-130px] xl:right-[-30px]">
          <div className="h-[280px]">
            <Image
              src={rightSection}
              alt="Right Section"
              loading="eager"
              height={800}
              width={800}
              className="h-full w-auto"
              priority
            />
          </div>
        </div>
        {/* iPhone */}
        <div className="absolute bottom-0 left-0 md:hidden">
          <div className="h-[110px] sm:h-[150px]">
            <Image
              src={iphoneImage}
              alt="iPhone"
              loading="eager"
              height={800}
              width={800}
              className="h-full w-auto"
              priority
            />
          </div>
        </div>
        {/* Smartwatch */}
        <div className="absolute right-0 bottom-0 md:hidden">
          <div className="h-[130px] xs:h-[150px]">
            <Image
              src={smartwatchImage}
              alt="Smartwatch"
              loading="eager"
              height={800}
              width={800}
              className="h-full w-auto"
              priority
            />
          </div>
        </div>
        {/* Nintendo Switch */}
        <div className="absolute top-0 right-[-70px] xxs:right-[-30px] xs:right-0 md:hidden">
          <div className="h-[110px] sm:h-[120px]">
            <Image
              src={switchImage}
              alt="Nintendo Switch"
              loading="eager"
              height={800}
              width={800}
              className="h-full w-auto"
              priority
            />
          </div>
        </div>
        <div className="relative">
          <div className="reebelo-container">
            <div className="flex flex-col items-center justify-center">
              <h1 className="mt-1.5 text-center text-lg font-light leading-tight xxs:text-xl xs:text-2xl md:text-3xl xl:text-4xl">
                <span className="font-semibold">The device</span> you want.{' '}
                <br />
                For a price <span className="font-semibold">you'll love.</span>
              </h1>
              <div className="mt-5 flex h-8 items-center justify-center rounded-full border-2 border-gray-700 !bg-gray-700 px-5 text-xs font-semibold text-white sm:mt-5">
                Shop Deals
              </div>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default DefaultHero;
